export const DRAMATIC = 'dramatic';
export const CLASSIC = 'classic';
export const NATURAL = 'natural';
export const GAMINE = 'gamine';
export const INGENUE = 'ingenue';
export const ROMANTIC = 'romantic';
